import { store } from "@/store"
import { signupWithRedirect } from "@/composables/useAccount.js"
import axios from "axios"
import { fetchAllPermissions, hasPermission } from "@/composables/usePermissions.js"

const manageGuard = async ({ params: { id } }) => {
  try {
    await store.dispatch("subscription/checkIfExists", id)
    return true
  }
  catch {
    return false
  }
}
import { RCA_CHECKOUT_ENABLED } from "@/store/modules/subscription.js"

const permissionGuard = permission => async ({ params: { id } }) => {
  try {
    return !!hasPermission(await fetchAllPermissions(), permission, id)
  }
  catch {
    return false
  }
}

const manageSubscriptionGuard = permissionGuard("manageSubscription")
const manageInstanceGuard = permissionGuard("manageInstance")

const signupGuard = () => signupWithRedirect()

const eligibilityGuard = async (to, from, next) => {
  try {
    await axios.get("/customer/subscriptions/eligibility")
    to.meta.canCreate = true
  }
  catch (error) {
    if (error.response && error.response.status === 403) {
      to.meta.canCreate = false
    }
    else {
      to.meta.canCreate = true
    }
  }
  next()
}

// Before the cutover the Salesforce checkout is closed, also to a typed or bookmarked URL. After it,
// anyone may use it: it only converts Salesforce trials, so a customer with a Chargebee trial buys a
// new instance there and their trial is left alone.
const rcaCheckoutGuard = (to, from, next) => (RCA_CHECKOUT_ENABLED ? next() : next("/"))

export {
  manageGuard,
  manageSubscriptionGuard,
  manageInstanceGuard,
  signupGuard,
  eligibilityGuard,
  rcaCheckoutGuard,
}
